import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'
import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'
import StockCardSectionDebits from './StockCardSectionDebits.vue'
import StockCardSectionControl from './StockCardSectionControl.vue'
import StockCardSectionInventoryTasks from './StockCardSectionInventoryTasks.vue'

export function getCustomTabsList (config) {
  const { access } = config
  return [
    {
      key: 'params',
      name: 'Общие сведения',
      props: [
        { key: '_commonProps', type: 'separator', name: 'Общие параметры' },
        { key: '$key', name: 'Идентификатор', _editable: false },
        { key: 'stockType', name: 'Тип склада', type: 'listvalue', _editable: access.editPublic },
        { key: 'stockStatus', name: 'Статус склада', type: 'listvalue', _editable: access.editPublic },
        // ===
        { key: '_additionalProps', type: 'separator', name: 'Дополнительные параметры' },
        { key: 'stationaryMain', name: 'Основной стационарный склад', type: 'boolean', _editable: access.editPublic },
        { key: 'purchaseStock', name: 'Склад для закупок', type: 'boolean', _editable: access.editPublic },
        { key: 'department', name: 'Отдел', _editable: access.editPublic, component: CardPropertyObjectCustom },
        // { key: 'inUse', name: 'Используется', type: 'boolean', _editable: access.editPublic }, // auto, box ???

        { key: 'commonStockBrigade', name: 'Бригады', _editable: access.editPublic, component: CardPropertyObjectTable, _show: o => o.stockType === 'common' },
        { key: 'stockBrigade', name: 'Бригада', _editable: access.editPublic, component: CardPropertyObjectCustom, _show: o => o.stockType === 'brigade' },
        { key: 'stockBox', name: 'Сотрудник', _editable: access.editPublic, component: CardPropertyObjectCustom, _show: o => o.stockType === 'box' },
        { key: 'stockOrganization', name: 'Организация', _editable: access.editPublic, component: CardPropertyObjectCustom, _show: o => o.stockType === 'dogovor' },
        { key: 'stockProject', name: 'Проект', _editable: access.editPublic, component: CardPropertyObjectCustom, _show: o => o.stockType === 'dogovor' },
        { key: 'vehicleStock', name: 'ТС', _editable: access.editPublic, component: CardPropertyObjectCustom, _show: o => o.stockType === 'auto' },
        { key: 'gosNomer', name: 'ГРЗ ТС', type: 'string', _editable: access.editPublic, _show: o => o.stockType === 'auto' },
        { key: 'marka', name: 'Марка ТС', type: 'string', _editable: access.editPublic, _show: o => o.stockType === 'auto' }
      ]
    },
    {
      key: 'stocksDebits',
      name: 'Остатки на складе',
      component: StockCardSectionDebits
    },
    {
      key: 'stockCardControlledTools',
      name: 'Контроль наличия',
      _show: o => o.stockType === 'auto',
      component: StockCardSectionControl
    },
    {
      key: 'stockCardInventoryTasks',
      name: 'Инвентаризация',
      _visible: access.viewStockInventoryTasks,
      _show: o => o.stockType === 'auto',
      component: StockCardSectionInventoryTasks
    }
    // {
    //   key: 'stocksDebits',
    //   name: 'Остатки на складе',
    //   props: [
    //     {
    //       key: 'stockTools',
    //       name: 'Инструменты',
    //       _editable: access.editPublic,
    //       component: CardPropertyObjectTable,
    //       componentProps: {
    //         columns: [
    //           { name: 'name', label: 'Название', type: 'string' },
    //           { name: 'incoming', label: 'Поступающее кол-во', type: 'double' },
    //           { name: 'outcoming', label: 'Расходуемое кол-во', type: 'double' },
    //           { name: 'nomAffilation', label: 'Принадлежность', type: 'string' }
    //         ],
    //         rowsPerPage: 20
    //       }
    //     },
    //     {
    //       key: 'objectStockTools',
    //       name: 'Инструменты для объекта',
    //       _editable: access.editPublic,
    //       _show: o => o.stockType === 'dogovor', // для склада типа Договор
    //       component: CardPropertyObjectTable,
    //       componentProps: {
    //         columns: [
    //           { name: 'name', label: 'Название', type: 'string' },
    //           { name: 'serviceObject', label: 'Объект обслуживания', type: 'integer' },
    //           { name: 'incoming', label: 'Поступающее кол-во', type: 'double' },
    //           { name: 'outcoming', label: 'Расходуемое кол-во', type: 'double' },
    //           { name: 'nomAffilation', label: 'Принадлежность', type: 'string' }
    //         ],
    //         rowsPerPage: 20
    //       }
    //     }
    //   ]
    // }
  ]
}
